const joinClassNames = (...classNames: (string | undefined | boolean)[]) => {
  return classNames.join(' ')
}

export default joinClassNames
